import { MeetingSession } from "@kalyzee/kast-web-sdk/websocket";
import { Activity, PopulatedMeeting } from "../contexts/meetingUtils/interfaces";
import { isExpert } from "./roles";

export const isBoardSession = (session: MeetingSession, activity?: Activity) => {
  return (
    isExpert(session.role) || (
      activity?.mode === "highlight"
      && activity.confirmedSessions.some(s => s.id === session.id)
    )
  );
};
